
import { getAntRegisterList } from '@/api/task/antRegister'
import { dateToSeconds, getSystemDate, pickerOptions } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import review from './components/review.vue'

@Component({
  name: 'antRegister',
  components: {
    review
  }
})
export default class extends Vue {
  private queryForm: any = {
    start_time: null,
    end_time: null,
    status: null, //	审核状态；0:待审核；1：批准；2：拒绝
    approved_by_name: '',
    // upstream_ordernumber: '',
    // content: ''
  }

  private date: any[] = getSystemDate()
  private pickerOptions = pickerOptions
  private listLoading: Boolean = false
  private taskList: any[] = []
  private total = 0

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  private reset() {
    this.queryForm = {
      start_time: null,
      end_time: null,
      status: null,
      approved_by_name: ''
    }
    this.date = getSystemDate()
    this.currentPage = 1
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      this.taskList = []
      await getAntRegisterList(data).then((res: any) => {
        this.total = res.count
        this.taskList = res.results
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  private currentTask: any | null = null
  private dialogVisible: boolean = false
  private openDialog(param: any) {
    this.currentTask = param
    this.dialogVisible = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  private async init() {
    this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.antRegister`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
